import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollTopModule } from '@app/layout/scroll-top/modules/scroll-top.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { AppDialogModule } from '@components/dialog/modules/app-dialog.module';
import { PanelTitleModule } from '@components/panel-title/panel-title.module';
import { SelectionListModule } from '@components/selection-list/modules/selection-list.module';
import { FuiNotifierService } from '@fui/fui-components';
import { SocketsModule } from '@fui/fui-sockets';
import { FuiDestroyService } from '@services/destroy.service';
import { NotifierService } from '@services/notifier.service';
import { MoaModule } from '@submodules/MOA/modules/moa.module';
import { MapModule } from 'submodules/map/map.module';
import { ProfilerModule } from 'submodules/profiler/profiler.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './core/app.routing.module';
import { FuiComponentsModule } from './core/fui-components.module';
import { GlobalModule } from './core/global.module';
import { MainModule } from './core/main.module';
import { BreadcrumbsModule } from './layout/breadcrumbs/modules/breadcrumbs.module';
import { FooterModule } from './layout/footer/modules/footer.module';
import { HeaderModule } from './layout/header/header.module';
import { SideMenuModule } from './layout/side-menu/modules/side-menu.module';
import { TableModule } from './modules/table/table.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        MainModule,
        GlobalModule,
        FuiComponentsModule,
        BreadcrumbsModule,
        FooterModule,
        HeaderModule,
        TableModule,
        SideMenuModule,
        ScrollTopModule,
        PanelTitleModule,
        AppDialogModule,
        SelectionListModule,
        ButtonModule,

        // Фи-модули подключаются ниже
        // Фи-модуль конструктора форм подключается в constructor.module.ts для обеспечения lazy-loading
        SocketsModule.forRoot(),
        ProfilerModule,
        MapModule,
        MoaModule,
    ],
    bootstrap: [AppComponent],
    providers: [FuiNotifierService, NotifierService, FuiDestroyService],
})
export class AppModule {}
